module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal-base', {
    staticClass: "fzg-about-partner-modal",
    on: {
      "hide-modal": _vm.hideModal
    }
  }, [_c('template', {
    slot: "header"
  }), _vm._v(" "), _c('template', {
    slot: "content"
  }, [_c('div', {
    staticClass: "partner-intro"
  }, [_c('div', {
    staticClass: "p-left"
  }, [_c('img', {
    staticClass: "photo",
    attrs: {
      "src": _vm.partnerData[_vm.partnerIndex].photo,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-right"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.partnerData[_vm.partnerIndex].name))]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.partnerData[_vm.partnerIndex].title))]), _vm._v(" "), _c('div', {
    staticClass: "intro"
  }, [_vm._v(_vm._s(_vm.partnerData[_vm.partnerIndex].intro))])])])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2879e74e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/FzgAboutPartnerModal.vue
// module id = 217
// module chunks = 0